import { gql } from '@apollo/client'

export default gql(`
    mutation(
        $name: String!    
        $project: String
   ) {
    createPartner(
            input: {
            name: $name         
            }
            project: $project
        ) {
            id
        }
    }`
)
